import {
  IPayment,
  PaymentLineType,
  PaymentStatus,
  PaymentTypeIds,
  TransactionStatus,
} from '@getgreenline/homi-shared'
import { LoyaltyModels } from '@getgreenline/loyalties'

export const samplePaymentForReceipt: IPayment = {
  id: 'id',
  customId: 'S000001',
  refundPaymentId: null,
  companyId: 1,
  locationId: 2,
  locationName: 'Location',
  locationAddress: 'Address',
  createDate: 'September 27, 2018',
  completeDate: new Date().toISOString(),
  customerId: 'customerId',
  customerName: 'Test customer',
  employeeId: 'employeeId',
  employeeName: 'Test employee',
  tax: 0,
  tendered: 0,
  pennyAdjustment: 0,
  subTotal: 11200,
  total: 11200,
  originalMonerisRefundTransactionId: null,
  externalSourceId: null,
  externalSourceName: null,
  externalOrderId: null,
  paymentLinesTotalDiscrepancy: null,
  paymentLines: [
    {
      id: 1,
      paymentId: 'payment id',
      productId: 'productId',
      productName: 'Vape cartridge',
      units: 1,
      unit: 'unit',
      inventorySubtracted: 1,
      price: 9000,
      depositFee: null,
      purchaseCost: 0,
      discountId: null,
      discountPrice: 0,
      discountMessage: null,
      cartDiscountPrice: 0,
      type: PaymentLineType.PRODUCT,
      barcode: null,
      shortDescription: '',
      batchId: null,
      batchNumber: null,
      isGiftCard: false,
      sku: '234567',
    },
    {
      id: 2,
      paymentId: 'payment id',
      productId: 'productId',
      productName: 'Purple Kush 1/8oz',
      units: 1,
      unit: 'gram',
      inventorySubtracted: 3.5,
      price: 2200,
      depositFee: null,
      purchaseCost: 0,
      discountId: null,
      discountPrice: 0,
      discountMessage: null,
      cartDiscountPrice: 0,
      type: PaymentLineType.PRODUCT,
      barcode: null,
      shortDescription: '',
      batchId: null,
      batchNumber: null,
      isGiftCard: false,
      sku: '123456',
    },
  ],
  taxPaymentLines: [],
  deviceId: null,
  deviceName: 'Device ID',
  notes: null,
  paymentQueueNotes: null,
  shiftId: null,
  wooCommerceOrderId: null,
  wooCommerceOrderJSON: null,
  status: PaymentStatus.COMPLETED,
  // The following settings will be replaced in the render
  receiptSettings: {
    receiptLocationNameText: null,
    receiptLocationDescriptionText: null,
    receiptAddressText: null,
    receiptFooterText: null,
    receiptShowEmployee: true,
    receiptShowSku: true,
  },
  offlinePaymentId: null,
  transactions: [
    {
      paymentTypeId: PaymentTypeIds.credit,
      amount: 11200,
      completeDate: new Date().toISOString(),
      status: TransactionStatus.COMPLETED,
      id: 1234,
      paymentId: 'id',
      paymentType: 'credit',
      merrcoInvoiceId: null,
      terminalInvoiceId: null,
      metadata: null,
    },
  ],
}

const loyaltyEarned = samplePaymentForReceipt.subTotal / 100
const loyaltyBalance = 10_000 + loyaltyEarned

export const sampleLoyaltyData: LoyaltyModels.ILoyaltyData = {
  mappedDiscountIdToAmount: new Map(),
  loyaltyBalance,
  loyaltyEarned,
}
